Browser = require 'lib/browser'
React = require 'react'
t = require('views/internal/recup-with-helpers')('create_first_board')
l = require 'lib/localize'
trackUe = require 'debug/trackUe'
{
  BOARD_NAME,
  LIST_NAME,
  CARD_NAME,
  CHECKITEM_NAME,
  CARD_DRAG,
  getInitialData,
} = require('views/create-first-board/constants')
{ CreateFirstBoardIds } = require '@trello/webdriverio-tests'

isInternetExplorer = Browser.browserVersionStr.indexOf('explorer') > -1 ||
  Browser.browserVersionStr.indexOf('edge') > -1

module.exports = class CreateFirstBoardComponent extends React.Component

  constructor: (props) ->
    super

    @steps = [
      BOARD_NAME,
      LIST_NAME,
      CARD_NAME,
      CHECKITEM_NAME,
      CARD_DRAG
    ]

    @state =
      currentStep: BOARD_NAME
      board: getInitialData()
      saving: false
      hasStarted: false

  validate: ->
    INITIAL_DATA = getInitialData()
    { currentStep, board } = @state
    if currentStep == BOARD_NAME
      board.name != ''
    else if currentStep == LIST_NAME
      board.lists.filter((list) -> list.name != '').length == INITIAL_DATA.lists.length
    else if currentStep == CARD_NAME
      board.lists[0].cards[0].name != ''
    else if currentStep == CHECKITEM_NAME
      # Allow user to pass this step, some may not want to enter a checkitem
      true
    else
      true

  continue: ->
    if @isLastStep()
      @submit()
    else
      @goToStep(@steps[@steps.indexOf(@state.currentStep) + 1], 'by clicking on continue footer')

  submit: (isSkip = false) ->
    INITIAL_DATA = getInitialData()
    if @state.saving
      return

    # before sending data to the submit callback, make sure to sanitize any data
    # like spaces in titles or empty inputs
    data = @state.board
    if data.name.trim() == ''
      data.name = INITIAL_DATA.defaultValue

    for list, index in data.lists
      if list.name.trim() == ''
        list.name = INITIAL_DATA.lists[index].name

    for card, index in data.lists[0].cards
      if card.name.trim() == ''
        card.name = INITIAL_DATA.lists[0].cards[index].defaultValue || ''

    if data.checkItem.trim() == ''
      data.checkItem = ''

    trackUe(
      'create first board view',
      'creates',
      'board',
      '',
      '',
      if isSkip then 'by clicking skip' else 'by clicking on the submit footer',
      { 'currentStep': @state.currentStep, 'stepCompleted': @validate() }
    )
    @setState({
      saving: true
    }, => @props.onSubmit(data))

  isLastStep: ->
    @steps.indexOf(@state.currentStep) == @steps.length - 1

  goToStep: (step, method) ->
    trackUe(
      'create first board view',
      'navigates',
      '',
      '',
      'to new step',
      method,
      {
        'currentStep': @state.currentStep,
        'nextStep': step,
        'stepCompleted': @validate()
      }
    )

    nextState = @state
    INITIAL_DATA = getInitialData()
    # Some views we show more cards than others...
    if step != BOARD_NAME && step != LIST_NAME
      nextState.board.lists[1].cards = []
      nextState.board.lists[2].cards = []
    else
      nextState.board.lists[1].cards = INITIAL_DATA.lists[1].cards
      nextState.board.lists[2].cards = INITIAL_DATA.lists[2].cards

    nextState.currentStep = step
    nextState.hasStarted = true

    @setState(nextState, ->
      if @state.currentStep == LIST_NAME
        @listInputRef0.select()
      else if !@isLastStep() && @validate()
        @footer.focus()
      else if @isLastStep()
        @footer.focus()
    )

  updateBoard: (value) ->
    @setState({
      board: Object.assign(@state.board, { name: value })
    })

  updateList: (index, value) ->
    nextState = @state
    @setState(=>
      nextState.board.lists[index] = {
        name: value
        cards: @state.board.lists[index].cards
      }
      nextState
    )

  updateCard: (index, value) ->
    nextState = @state
    @setState(=>
      nextState.board.lists[0].cards[index] = {
        name: value
      }
      nextState
    )

  updateCheckItem: (value) ->
    nextState = @state
    @setState(=>
      nextState.board.checkItem = value
      nextState
    )

  handleClickFooter: (e) ->
    # https://github.com/facebook/react/issues/3907
    if e.detail == 0
      return
    @continue()

  handleKeyPressSubmit: (e) ->
    if @validate() && e.key == 'Enter'
      @continue()

  handleListKeyPress: (e, index) ->
    if @validate() && e.key == 'Enter'
      if index in [0, 1]
        @["listInputRef#{index + 1}"].select()
      else
        @continue()

  renderStepChildren: ->
    { currentStep, board } = @state
    if currentStep == BOARD_NAME
      t.div ".#{BOARD_NAME}", =>
        t.h2 =>
          t.format 'welcome-to-trello'
        t.p =>
          t.format 'you-can-organize-just-about-anything-with-a-trello-board'
          t.span '.show-point-right', =>
            t.format 'that-thing-over-there'
          t.span '.show-point-up', =>
            t.format 'that-thing-up-there'
        t.p =>
          t.format 'start-by-naming-your-board-something-related-to-the-project'
        t.input {
          key: 1
          placeholder: t.l('eg-vacation-planning')
          maxLength: "32"
          value: board.name
          onChange: (e) => @updateBoard(e.target.value)
          onKeyPress: (e) => @handleKeyPressSubmit(e)
          'data-test-id': CreateFirstBoardIds.BoardNameInput
        }
    else if currentStep == LIST_NAME
      t.div ".#{LIST_NAME}", =>
        t.h2 =>
          t.format 'create-structure-with-lists'
        t.p =>
          t.format 'a-list-is-a-collection-of-cards'
        t.p =>
          t.format 'a-lot-of-people-like-to-start-with'
        t.input {
          key: 2
          value: board.lists[0].name
          maxLength: "16"
          onChange: (e) => @updateList(0, e.target.value)
          onKeyPress: (e) => @handleListKeyPress(e, 0)
          'data-test-id': CreateFirstBoardIds.ListNameInput
          ref: (r) => (@listInputRef0 = r)
        }
        t.input {
          key: 3
          value: board.lists[1].name
          maxLength: "16"
          onChange: (e) => @updateList(1, e.target.value)
          onKeyPress: (e) => @handleListKeyPress(e, 1)
          ref: (r) => (@listInputRef1 = r)
        }
        t.div '.third-input', =>
          t.span =>
            t.format 'and'
          t.input {
            key: 4
            maxLength: "16"
            value: board.lists[2].name
            onChange: (e) => @updateList(2, e.target.value)
            onKeyPress: (e) => @handleListKeyPress(e, 2)
            ref: (r) => (@listInputRef2 = r)
          }
        t.p '.post-input', =>
          t.format 'go-ahead-and-rename-your-lists-if-youd-like'
    else if currentStep == CARD_NAME
      t.div ".#{CARD_NAME}", =>
        t.h2 =>
          t.format 'take-a-load-off-with-cards'
        t.p =>
          t.format 'make-cards-for-things'
        t.p =>
          t.span {
            dangerouslySetInnerHTML: {
              __html: l(
                'add titles for a few cards in your named list',
                listName: board.lists[0].name
              )
            }
          }

        t.input {
          key: 5
          placeholder: t.l('eg-book-flights')
          maxLength: "32"
          value: board.lists[0].cards[0].name
          onChange: (e) => @updateCard(0, e.target.value)
          onKeyPress: (e) => @handleKeyPressSubmit(e)
          'data-test-id': CreateFirstBoardIds.CardNameInput
        }
        t.input {
          key: 6
          placeholder: t.l('eg-find-a-hotel')
          maxLength: "32"
          value: board.lists[0].cards[1].name
          onChange: (e) => @updateCard(1, e.target.value)
          onKeyPress: (e) => @handleKeyPressSubmit(e)
        }
        t.div '.third-input', =>
          t.span =>
            t.format 'and'
          t.input {
            key: 7
            placeholder: t.l('eg-call-dogsitter')
            maxLength: "32"
            value: board.lists[0].cards[2].name
            onChange: (e) => @updateCard(2, e.target.value)
            onKeyPress: (e) => @handleKeyPressSubmit(e)
          }
    else if currentStep == CHECKITEM_NAME
      t.div ".#{CHECKITEM_NAME}", =>
        t.h2 =>
          t.format 'get-into-the-details'
        t.p =>
          t.format 'when-you-click-on-a-card-you-can-add-just-about-any-kind-of-info'
        t.p {
          dangerouslySetInnerHTML: {
            __html: l(
              'start by adding a checklist item to your named card',
              cardName: board.lists[0].cards[0].name
            )
          }
        }
        t.div '.checklist-item', =>
          t.div '.checklist-box'
          t.input {
            key: 8
            placeholder: t.l('eg-do-something')
            maxLength: "28"
            value: board.checkItem
            onChange: (e) => @updateCheckItem(e.target.value)
            onKeyPress: (e) => @handleKeyPressSubmit(e)
            'data-test-id': CreateFirstBoardIds.ChecklistInput
          }
    else if currentStep == CARD_DRAG
      t.div ".#{CARD_DRAG}", =>
        t.h2 =>
          t.format 'your-ready-to-get-started'
        t.p =>
          t.format 'now-that-you-understand-the-basics'

  renderPreview: ->
    { currentStep, board, hasStarted } = @state
    firstList = board.lists[0]
    firstCard = firstList.cards[0]

    if currentStep == CARD_DRAG
      t.img {
        src: require('images/create-first-board/card-drag.gif')
      }
      t.div =>
        t.h2 =>
          t.format 'one-last-tip'
        t.p =>
          t.format 'get-those-cards-moving'
    else
      t.div '.board-name-display', =>
        t.p {
          className: t.classify({
            'is-active': !!board.name
          })
          'data-test-id': CreateFirstBoardIds.BoardNameDisplay
        }, => t.text board.name
      t.div '.first-board-image-list-container', =>
        for li, list of board.lists
          t.div '.first-board-image-list.list-name-display', {
            className: t.classify({
              'first-board-image-list-empty': list.cards.length == 0
            })
          }, =>
            t.p {
              className: t.classify({
                'is-active': hasStarted && list.name != ''
              })
              'data-test-id': if li == '0'
                CreateFirstBoardIds.ListNameDisplay
            }, =>
              if hasStarted
                t.text list.name
            for ci, card of list.cards
              t.div '.first-board-image-card.card-name-display', {
                className: t.classify({
                  'large': !!card.large
                })
              }, =>
                t.p {
                  className: t.classify({
                    'is-active': !!card.name
                  })
                  'data-test-id': if li == '0' && ci == '0'
                    CreateFirstBoardIds.CardNameDisplay
                }, => t.text card.name
      if currentStep == CHECKITEM_NAME
        t.div '.first-board-card-back', =>
          t.img {
            src: require('images/create-first-board/low-fidelity-card-back.svg')
            className: 'check-name-image'
          }
          t.div '.check-name-display', =>
            t.p => t.text firstCard.name || l('untitled card')
            if !board.checkItem
              t.p '.check-name-placeholder', =>
                t.format 'add-an-item'
            else
              t.p {
                'data-test-id': CreateFirstBoardIds.ChecklistDisplay
              }, => t.text board.checkItem

  renderFooter: ->
    { currentStep, saving } = @state

    t.button {
      className: t.classify({
        'first-board-continue-footer': true
        'is-active': @validate() && !saving
        'submit-footer': @isLastStep()
        'disabled': !@validate() || saving
      })
      onClick: (e) => @handleClickFooter(e)
      onKeyDown: (e) => @handleKeyPressSubmit(e)
      'data-test-id': CreateFirstBoardIds.ContinueButton
      'disabled': !@validate() || saving
      ref: (r) => (@footer = r)
    }, =>
      if @isLastStep()
        t.format 'now-youre-a-pro-keep-building-your-board'
      else
        t.icon 'down'

  render: t.renderable ->
    { board, currentStep } = @state

    t.div '.first-board-container', =>
      # mock board
      t.div '.first-board-column.first-board-image.board-name-background', =>
        t.div '.first-board-image-wrapper', =>
          t.div '.first-board-image-base', {
            className: t.classify({
              'first-board-image-base--mod-card-drag': currentStep == CARD_DRAG
              'first-board-image-base--mod-ie': currentStep == CHECKITEM_NAME &&
                isInternetExplorer
            })
          }, =>
            @renderPreview()

      t.div '.first-board-column.first-board-content-wrapper', =>
        t.div '.first-board-content', =>
          t.div '.first-board-navigation', =>
            @steps.map (step, index) =>
              t.createElement('span', {
                key: index
                className: t.classify({
                  'current-step': step == currentStep
                })
                onClick: => @goToStep(step, 'by clicking navigation dot')
              })
          t.div '.first-board-text-wrapper', =>
            t.div '.first-board-text', =>
              @renderStepChildren()
              @renderFooter()



// WEBPACK FOOTER //
// ./app/scripts/views/create-first-board/create-first-board.coffee